const mutations = {
  SET_INTRADAY_UPDATES (state, { intraday_updates }) {
    state.intraday_updates = intraday_updates
  }
}

export default mutations
